// Angular
import { Component, Input } from "@angular/core";
import { RouterLink } from "@angular/router";
import { FormsModule } from "@angular/forms";

// Types
import { NavigationLayoutItem } from "#src/app/core/models/navigation";

// Ant
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzIconModule } from "ng-zorro-antd/icon";

// Pipes
import { TranslatePipe } from "#pipes/i18n/translate.pipe";

// Components
import { NavigationBaseComponent } from "#components/navigation-base/navigation-base.component";

@Component({
    selector: "app-navigation",
    imports: [
        RouterLink,
        TranslatePipe,
        NzIconModule,
        NzLayoutModule,
        NzMenuModule,
        NzButtonModule,
        NzSelectModule,
        FormsModule,
    ],
    templateUrl: "./navigation.component.html",
    styleUrl: "./navigation.component.scss",
})
export class NavigationComponent extends NavigationBaseComponent {
    @Input() isCollapsed!: boolean;

    getRoute() {
        return this.router.url.split("?")[0];
    }

    promoMatcher(item: NavigationLayoutItem) {
        const routePath = this.getRoute();
        const queryParams = this.getQueryParams();

        if (queryParams["filters[type_id]"]) {
            if (!item.queryParams) {
                return false;
            }

            return item.queryParams["filters[type_id]"] == queryParams["filters[type_id]"];
        }

        return (
            item.queryParams &&
            item.queryParams["filters[type_id]"] === null &&
            routePath === item?.link
        );
    }

    defaultMatcher(link: string) {
        return this.getRoute() === link;
    }

    matcher(item: NavigationLayoutItem, matcherType = "") {
        switch (matcherType) {
            case "promos":
                return this.promoMatcher(item);
            default:
                return this.defaultMatcher(item.link);
        }
    }

    onClickEvent(e: MouseEvent, item: NavigationLayoutItem) {
        if (item.callback) {
            e.preventDefault();
            item.callback(item);

            return false;
        }

        return true;
    }

    getClassBasedOnLink(link: string) {
        return `navigation-link-item ${link.split("?")[0]}`
            .replaceAll("/", "_")
            .replaceAll("-", "_");
    }
}
